module.exports = __webpack_public_path__ + "static/media/2fast2ctf.46131bd9.png";